const partialRadioButton = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsRadioButton.hbs');
const partialDisplayField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDisplayFields.hbs');

const utils = require ('../detail_utilities.js');

define(function (require) {

	var getRadio = function (ele, readOnlyForm, detailOptions) {

		// Building title label
		var displayData = {
			fieldset: true,
			id: ele.id,
			classes: ele.isVisible === false ? 'hidden radiobutton-container':'radiobutton-container',
			labelText: ele.text,
			required: ele.isRequired,
			helperMsg: " ",
			helperMsgId: ele.id + "-helper",
			html:ele.isHtml,
			disabled: (readOnlyForm || ele.isEnabled === false),
			showValue: true
		};

		var el = $(partialDisplayField($.extend({}, displayData)));

		// Building radio button list
		var radioButtonContainer = $('<div/>', {
			class: 'field-row',
			name: ele.bind ? ele.bind : ele.id,
		});
		el.append(radioButtonContainer);

		_.forEach(ele.valueSelections, function (value) {
			if (value.selected)
				checked = "checked";

			var radioData = {
				//the new theme uses labels, so the IDs need to be different to get the
				//visual representation of a filled radio button to appear correctly.
				id: ele.id+'_'+utils.S4(),
				qaid: utils.formatId(ele.text, value.value +' '+ ele.type),
				name: ele.bind ? ele.bind : ele.id,
				labelText: ele.text,
				value: value.value,
				checked: value.selected,
				disabled: (readOnlyForm || ele.isEnabled === false),
				text: value.text,
				classes: ele.isVisible === false ? 'hidden':'',
				required: ele.isRequired
			};

			radioButtonContainer.append(partialRadioButton($.extend({}, radioData)));
		});

		return el;
	};
	return {
		getRadio: function(ele, readOnlyForm, detailOptions) {
			return getRadio(ele, readOnlyForm, detailOptions);
		}
	}
});